import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface VideoFile {
  id: string;
  name: string;
  video_url: string;
  video_url_webm?: string;
  video_url_mp4?: string;
  thumbnail_url: string;
  active: boolean;
  created_at: string;
}

interface UseActiveHomepageVideoOptions {
  enabled?: boolean;
}

export const useActiveHomepageVideo = (options: UseActiveHomepageVideoOptions = {}) => {
  const { enabled = true } = options;

  return useQuery({
    queryKey: ['active-homepage-video'],
    queryFn: async (): Promise<VideoFile | null> => {
      try {
        const { data, error } = await supabase
          .from('home_videos')
          .select('*')
          .eq('active', true)
          .maybeSingle();

        if (error) {
          console.error('Error fetching active homepage video:', error);
          throw new Error(`Failed to fetch active homepage video: ${error.message}`);
        }

        return data;
      } catch (error) {
        console.error('Active homepage video fetch failed:', error);
        throw error;
      }
    },
    enabled, // Control when the query runs
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes  
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 1,
    retryDelay: 1000,
  });
};